<template>
  <div class="width100 margin-auto pad-bot30">
    <div class="all-title f16 dimensional"><span>新增成员</span></div>
    <!-- 检索 -->
    <div class="Retrieveform">
      <p class="bluecolor">{{ title }}</p>
      <div class="flexleft pad-top30">
        <div
          class="width100 f12 margin-bot10 flex-betweenwrap"
          style="color: #969eac"
        >
          <span>手机号码</span
          ><span> 输入手机号码 ，将人员加入企业协同管理团队，每行一个</span>
        </div>
        <div class="width100 Numberbox">
          <el-input
            placeholder="请输入人员手机号进行查找,每行一个手机号"
            type="textarea"
            :autosize="autosize"
            v-model="form.desc"
            @change="change($event)"
            rows="5"
          ></el-input>
        </div>
      </div>
      <div class="flex-betweenNowrapAlign pad-top10">
        <p class="pad-top10 f14" v-if="numtotle">
          已过滤已有成员，共找到{{ numtotle }}位用户
          <el-checkbox
            class="margin-left10"
            v-model="checked"
            @change="chexboxall($event)"
            >全选</el-checkbox
          >
        </p>
        <div class="f14 cursorpointer">
          <el-button
            class="margin-top20 f14"
            type="primary"
            @click="searchpeaple()"
          >
            查 找
          </el-button>
        </div>
      </div>
      <div class="pad-top10 width96"></div>
      <div v-if="addbox" class="width96 margin-auto">
        <div>
          <el-checkbox-group
            v-model="checkList"
            @change="chexbox($event)"
            class="flex-leftwrap"
          >
            <el-checkbox
              class="width20 pad-top10 f12"
              v-for="(item, index) in pages"
              :key="index"
              :label="item.id"
              >{{ item.realname }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div class="textalign-right margin-top40">
        <span v-if="addbox" class="margin-right10">
          <el-button @click="allheadpipo()">设为企业负责人</el-button>
          <el-button @click="allAddpipo()">设为高级管理员</el-button>
          <el-button @click="allpipo()">设为普通用户</el-button>
        </span>

        <el-button class="f14" @click="nullpeaple()"> 关 闭 </el-button>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { authSearch } from "@/api/personal/personal.api";
import { bindaddstaff, bindstafflist } from "@/api/loader/loder.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      errormessage: "",
      dialogVisiblenull: false,
      page: "",
      pages: "",
      centerNum: "",
      user_id: "",
      form: {
        desc: "",
      },
      as: [],
      userid: [],
      numtotle: "",
      addbox: false,
      title: "",
      checked: false,
      checkList: [],
      bindstafflistall: [],
    };
  },
  methods: {
    onClickEnter() {
      // this.form.desc + ','
    },
    // 人员查找
    change($event) {
      this.as = $event.split("\n");
    },
    searchpeaple() {
      this.refresh();
      if (this.form.desc == "") {
        this.form.desc = "";
        this.numtotle = "";
        this.userid = [];
        this.checkList = [];
        this.checked = false;
        this.pages = [];
        this.dialogVisiblenull = true;
        this.errormessage = "请输入手机号码查找";
      } else {
        this.bindstafflistall.forEach((i) => {
          if (this.as.indexOf(i) != -1) {
            this.as.splice(this.as.indexOf(i), 1);
          }
        });
        if (this.as == "") {
          this.dialogVisiblenull = true;
          this.errormessage = "当前成员已经存在";
        } else {
          //   根据手机号查询
          authSearch({ mobile: this.as }).then((res) => {
            if (res.data.code == 200) {
              this.numtotle = res.data.data.length;
              this.pages = res.data.data;
              this.addbox = true;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        }
      }

      // }
    },
    chexboxall($event) {
      if ($event == true) {
        this.pages.forEach((i) => {
          this.userid.push(i.id);
          this.checkList = this.userid;
        });
      } else {
        this.userid = [];
        this.checkList = [];
      }
    },
    // 选择的id
    chexbox($event) {
      this.userid = $event;
      if (this.userid.length == this.pages.length && this.pages.length != 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    allheadpipo() {
      bindaddstaff({
        ent_id: window.sessionStorage.getItem("default"),
        user_id: this.userid,
        authority: 0,
      }).then((res) => {
        if (res.data.code == 200) {
          this.nullpeaple();
          this.refresh();
          BUS.$emit("addpeople", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    nullpeaple() {
      this.addbox = false;
      this.form.desc = "";
      this.numtotle = "";
      this.userid = [];
      this.checkList = [];
      this.checked = false;
      this.pages = [];
      BUS.$emit("addpeople", "yess");
    },
    // 批量添加高级管理员
    allAddpipo() {
      bindaddstaff({
        ent_id: window.sessionStorage.getItem("default"),
        user_id: this.userid,
        authority: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.nullpeaple();
          this.refresh();
          BUS.$emit("addpeople", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 批量添加普通用户
    allpipo() {
      bindaddstaff({
        ent_id: window.sessionStorage.getItem("default"),
        user_id: this.userid,
        authority: 2,
      }).then((res) => {
        if (res.data.code == 200) {
          this.nullpeaple();
          this.refresh();
          BUS.$emit("addpeople", "yes");
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      bindstafflist({
        all: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data;
          this.page.forEach((i) => {
            this.bindstafflistall.push(i.user.mobile);
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.title = window.sessionStorage.getItem("companytitle");
    bindstafflist({
      all: 1,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
        this.page.forEach((i) => {
          this.bindstafflistall.push(i.user.mobile);
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    this.$keyBoard(this, "onClickEnter", 13); // 13就是回车键的keycode,这样点击回车就能触发onClickEnter这个事件了
  },
};
</script>
<style scoped>
.all-title {
  height: 56px;
  line-height: 56px;
  text-align: left;
}
.Retrieveform {
  background: #fff;
}
.Project-boder {
  border-bottom: 1px solid #efefef;
}

.setlook {
  background: white;
  width: 10%;
  text-align: center;
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  margin-left: 60px;
  border: 1px solid #bbbbbb;
}
.Numberbox {
  background: white;
}
.Permission-configuration {
  background: #409eff;
  color: white;
  width: 80px;
  text-align: center;
  border-radius: 5px;
  line-height: 30px;
  float: right;
  margin-top: 30px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>